module.exports = __webpack_public_path__ + "img/slika32.ddc515bb.jpg";